import { Box, Button, Fab, Grid, TextField, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  convertDateToCustomFormat,
  getFirstDateOfCurrentMonthPayloadFormate,
  getLastDateOfCurrentMonthPayloadFormat,
} from "../../utils/commonUtils";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { VendorRegistration } from "../vendorRegistration/vendorRegistration";
import Quatation from "../quetation/question";
import { addPuchaseOrder, getAllProdct } from "./purchaseManagmentApi";
import AddPuchaseOrder from "./purchaseModalAdd.jsx";
import AddIcon from "@mui/icons-material/Add";
import CardPayment from "../payment/cardPayment.jsx";
import { QuetatioinPage } from "../quetation/quotetation.jsx";
import { IconButton } from "@mui/material";
import dayjs from "dayjs";
import {
  Card,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useRef } from "react";
import html2pdf from "html2pdf.js";
import TermsAndConditions from "./tAndC.jsx";
import { getVendors } from "../vendorRegistration/vendorRegistrationApi.js";
import { getBillerTAndCByType } from "./termsAndConditionsApi.js";
import { useTheme } from "@emotion/react";
import Heading from "../../common/Heading.jsx";
export const PurchaseMagnemt = () => {
  const [open, setOpen] = useState(false);
  const receptRef = useRef();
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const infoD = useSelector((state) => state.reducer.detail);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [collection, setCollection] = useState([]);
  const cardKet = {
    persnoalInf: [
      {
        key: "purchaseOrderNumber",
        label: "PO ID",
        color: "#bb4a9b",
      },
      {
        key: "vendorName",
        label: "Vendor Name",
        color: "#bb4a9b",
      },
      {
        key: "date",
        // color: "black",
        label: "Date",
        splitF: { target: "T", index: 0 },
      },
      {
        key: "validTill",
        // color: "black",
        label: "Valid Till",
        splitF: { target: "T", index: 0 },
      },
      {
        key: "totalAmount",
        // color: "black",
        label: "Total Amount",
      },

      // {
      //   keys: ["paymentPercentage", "salaryorPercentage"],
      //   color: "#3695B6",
      //   label: "Payment Percentage",
      // },
    ],
    educationalDetail: [
      {
        key: "courseName",
        label: "Course Name",
      },
      {
        key: "courseDetails",
        label: "Component Name",
      },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "grade",
      },
      {
        key: "institute",
        label: "institute",
      },
      {
        key: "university",
        label: "university",
      },
    ],

    incentrive: [
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };
  // 10 16 15 17 18
  useEffect(() => {
    console.log("purchase data businessChooseTab?.value", userDetail);
    if (userDetail && userDetail?.profileId) {
      let val = userDetail?.profileId?.split("?")[1];
      getAllProdct(
        {
          billerId: val.split("=")[1]?.replace(/\D/g, ""),
        },
        (res) => {
          console.log("res getall product ", res?.data);
          setCollection([...res?.data]);
        }
      );
    }
  }, [userDetail]);

  const [modaldata, setModalData] = useState(null);

  // ..Get vendor List
  const [vendorList, setVendorList] = useState([]);
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await getVendors();
        // Access nested data list properly here
        if (res?.data?.data?.list) {
          setVendorList(res.data.data.list);
        } else {
          console.warn("No vendor list found in response", res);
        }
      } catch (err) {
        console.error("Error fetching vendors", err);
      }
    };

    fetchVendors();
  }, []);
  const getVendorDetails = (vendorId) => {
    return vendorList.find((vendor) => vendor.id === vendorId);
  };

  console.log("..........111", vendorList);

  // Term and Condition
  const [termAndCondition, setTermAndCondition] = useState("");

  useEffect(() => {
    const fetchTermAndCondition = async () => {
      try {
        const res = await getBillerTAndCByType("Purchase");
        const detailss = res?.data?.data?.details;
        setTermAndCondition(detailss);
      } catch (error) {}
    };
    fetchTermAndCondition();
  }, []);
  // .......,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
  useEffect(() => {
    console.log("info d info ", infoD);
  }, [infoD]);
  // console.log("modaldata!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", modaldata);

  const htmlToPDF = async (componentRef, fileName = "purchase-order.pdf") => {
    const element = componentRef.current;
    const options = {
      margin: 0.5,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .from(element)
        .set(options)
        .output("blob");
      return pdfBlob;
    } catch (error) {
      console.error("Error generating PDF", error);
      return null;
    }
  };

  const handleDownload = async (item) => {
    setModalData(item);

    // Wait for modalData to render and DOM to update
    await new Promise((resolve) => setTimeout(resolve, 200));

    // --- Generate custom file name ---
    const now = new Date();

    const day = now.getDate().toString().padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    let hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const seconds = now.getSeconds().toString().padStart(2, "0");
    const isPM = hours >= 12;
    const ampm = isPM ? "PM" : "AM";
    hours = hours % 12 || 12; // 12-hour format
    const hourStr = hours.toString().padStart(2, "0");

    const poNumber = item?.purchaseOrderNumber?.replaceAll("/", "_") || "PO";
    const fileName = `PO${day}-${month}-${year}_${hourStr}-${minutes}-${seconds}_${ampm}.pdf`;

    const blob = await htmlToPDF(receptRef, fileName);

    if (blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };
  const columnCount = cardKet.persnoalInf.length + 1;
  const columnXS = Math.floor(12 / columnCount);
   const theme = useTheme();
   const isAbove1440 = useMediaQuery("(min-width:1440px)");
  return (
    <Box
      px={2}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      {businessChooseTab?.value === "PurchaseManagment" && (
        <>
          <Grid container alignItems="center" >
            <Grid item xs={5} sm={8} md={9} lg={9}>
              <Heading name="Employee Access" />
            </Grid>
            {/* <Grid
              item
              xs={5}
              sm={8}
              md={9}
              lg={9}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                borderRadius: "5px",
                color: "#01008B",
                marginBottom: "20px",
              }}
            >
              
              <Typography
                // variant="h6"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  fontWeight: 500,
                }}
              >
                Purchase Order
              </Typography>
              
            </Grid> */}
            <Grid item xs={7} sm={4} md={3} lg={isAbove1440 ? 3 : 2}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  height: { lg: "40px", md: "35px", sm: "35px", xs: "30px" },
                  backgroundColor: "#14008B",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "14px" },
                }}
                onClick={() => setOpen(true)}
                size="small"
                color="primary"
                aria-label="add"
              >
                Add Purchase Order
                <AddIcon
                  sx={{
                    ml: 1,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                />
              </Button>
            </Grid>
          </Grid>

          {/* <Grid container spacing={2} sx={{ mt: 1 }}>
            {collection?.map((item, index) => (
              <Grid item xs={4} key={index}>
                <CardPayment
                  item={item}
                  setOpen={() => {}}
                  setModalData={(dat) => {
                    let obj = {};
                    Object.keys(dat).forEach((key) => {
                      obj[key] =
                        dat[key] && dat[key] !== "null" ? dat[key] : "";
                    });

                    console.log("Formatted modal data:", obj);

                    setModalData(item);
                    setOpen(true);
                  }}
                  cardKet={cardKet?.persnoalInf}
                />
              </Grid>
            ))}
          </Grid> */}

          <Grid
            container
            sx={{
              p: "10px",
              px: 2,
              mt: 2,
              background: "white",
              borderRadius: "12px",
              overflowX: "auto",
            }}
          >
            <Box sx={{ minWidth: "600px", width: "100%" }}>
              <Grid container>
                <Grid item xs={12}>
                  {/* Table Header */}
                  <Grid
                    container
                    sx={{
                      borderBottom: "1.5px solid black",
                      padding: "10px",
                      mb: 2,
                    }}
                  >
                    {cardKet.persnoalInf.map((field, index) => (
                      <Grid
                        item
                        // xs={12 / (cardKet.persnoalInf.length + 1)}
                        xs={columnXS}
                        key={index}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            textAlign: "center",
                            fontWeight: 500,
                            color: "#01008B",
                          }}
                        >
                          {field.label}
                        </Typography>
                      </Grid>
                    ))}

                    <Grid
                      item
                      xs={12 / (cardKet.persnoalInf.length + 1)}
                    ></Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    height: "60vh",
                    overflowY: "auto",
                    marginTop: "1px",
                    // padding: "15px",
                  }}
                >
                  {/* Table Rows */}
                  {collection.map((item, i) => (
                    <Grid
                      container
                      key={"purchaseRow" + i}
                      onClick={() => {
                        let obj = {};
                        Object.keys(item).forEach((key) => {
                          obj[key] =
                            item[key] && item[key] !== "null" ? item[key] : "";
                        });
                        setModalData(item);
                        setOpen(true);
                      }}
                      sx={{
                        p: "5px",
                        borderBottom: "1px solid #eee",
                        alignItems: "center",
                        backgroundColor: "#E8E8FF",
                        borderRadius: "8px",
                        mb: 1,
                        cursor: "pointer",

                        // marginLeft: "30px",
                      }}
                    >
                      {cardKet.persnoalInf.map((field, j) => {
                        let value = item[field.key];

                        if (
                          (field.key === "date" || field.key === "validTill") &&
                          value
                        ) {
                          value = dayjs(value).format("DD-MMM-YYYY");
                        }

                        return (
                          <Grid
                            item
                            // xs={12 / (cardKet.persnoalInf.length + 1)}
                            xs={columnXS}
                            key={j}
                          >
                            <Typography
                              sx={{
                                textAlign:
                                  field.key === "totalAmount"
                                    ? "right"
                                    : field.key === "vendorName"
                                      ? "left"
                                      : "center",
                                fontWeight: 500,
                                pr:
                                  field.key === "totalAmount"
                                    ? { xs: 1, sm: 1, lg: 4 }
                                    : 0,
                                pl:
                                  field.key === "vendorName"
                                    ? { xs: 2, sm: 2, md: 3, lg: 6 }
                                    : // : row.key === "vendorName"
                                      // ? { xs: 2, sm: 4, md: 6, lg: 12 } // 👈 different padding for mobile
                                      0,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {value !== undefined &&
                              value !== null &&
                              value !== "null"
                                ? field.key === "totalAmount"
                                  ? `₹ ${Number(value).toLocaleString("en-IN")}`
                                  : value
                                : "-"}
                            </Typography>
                          </Grid>
                        );
                      })}

                      <Grid item xs={columnXS}>
                        <Box display="flex" justifyContent="center">
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(item);
                              console.log("Download clicked for item:", item);
                            }}
                            sx={{
                              p: 0,
                            }}
                          >
                            <FileDownloadIcon
                              sx={{
                                fontSize: {
                                  xs: "15px",
                                  sm: "15px",
                                  md: "25px",
                                },
                                color: "#01008B",
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  ))}
                  {/* ................................................................................................... */}
                  {/* ....Pdf */}
                  {modaldata &&
                    (() => {
                      const vendor = getVendorDetails(modaldata?.vendorId);
                      return (
                        <Card
                          sx={{
                            maxWidth: 800,
                            mx: "auto",
                            p: 2,
                            position: "fixed",
                            top: 0,
                            left: 0,
                            opacity: 0,
                            pointerEvents: "none",
                            zIndex: -999,
                            fontFamily: "Arial",
                          }}
                        >
                          <Box
                            ref={receptRef}
                            sx={{ position: "relative", mx: "auto" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                mb: 2,
                              }}
                            >
                              {/* Left: Logo */}
                              <Box sx={{ width: "100px", height: "100px" }}>
                                <img
                                  src={userDetail?.logoPath}
                                  alt="Logo"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </Box>

                              {/* Center: Title */}
                              <Box sx={{ flexGrow: 1, textAlign: "center" }}>
                                <Typography
                                  sx={{
                                    fontSize: "22px",
                                    fontWeight: "bold",
                                    color: "#0C1E5B",
                                    letterSpacing: 1,
                                  }}
                                >
                                  PURCHASE ORDER
                                </Typography>
                              </Box>

                              {/* Right: empty box to balance layout */}
                              <Box sx={{ width: "80px", height: "80px" }} />
                            </Box>

                            <Divider
                              sx={{ borderBottom: "6px solid black", my: 2 }}
                            />

                            <Grid container spacing={2}>
                              {/* Left: Supplier Details */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                    }}
                                  >
                                    Order (PO) Number:
                                  </Typography>
                                  <Typography>
                                    {modaldata?.purchaseOrderNumber}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                    }}
                                  >
                                    Order (PO) Date:
                                  </Typography>
                                  <Typography>
                                    {modaldata?.date
                                      ? dayjs(modaldata.date).format(
                                          "DD-MMM-YYYY",
                                        )
                                      : ""}
                                  </Typography>
                                </Box>

                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    mt: 2,
                                    color: "#0C1E5B",
                                  }}
                                >
                                  Supplier Details:
                                </Typography>
                                <Box sx={{ mt: 2 }}>
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                    }}
                                  >
                                    {vendor?.vendorName || "-"}
                                  </Typography>
                                  <Typography>
                                    {vendor?.companyAddress || "-"}
                                  </Typography>
                                  <Typography>
                                    Mobile: {vendor?.mobileNumber || "-"}
                                  </Typography>
                                  <Typography>
                                    GSTIN:{" "}
                                    {vendor?.gstRegistrationNumber || "-"}
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* Right: Purchaser Details */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    mt: 3,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                    }}
                                  >
                                    Order (PO) Validity:
                                  </Typography>
                                  <Typography>
                                    {modaldata?.validTill
                                      ? dayjs(modaldata.validTill).format(
                                          "DD-MMM-YYYY",
                                        )
                                      : ""}
                                  </Typography>
                                </Box>

                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    mt: 2,
                                    color: "#0C1E5B",
                                  }}
                                >
                                  Purchaser Details:
                                </Typography>
                                <Box sx={{ mt: 2 }}>
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                    }}
                                  >
                                    {userDetail?.myBusinessName}
                                  </Typography>
                                  <Typography>
                                    {" "}
                                    {userDetail?.billerAddress}
                                  </Typography>
                                  <Typography>
                                    Mobile: {userDetail?.mobileNumber}
                                  </Typography>
                                  <Typography>
                                    GSTIN: {userDetail?.gstRegistrationNumber}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>

                            <Divider
                              sx={{
                                color: "#0C1E5B",
                                fontWeight: "bold",
                                borderBottom: "2px solid black",
                                mt: 2,
                              }}
                            />

                            {/* Table Section */}
                            <TableContainer component={Paper} elevation={0}>
                              <Table
                                sx={{ minWidth: 650 }}
                                aria-label="purchase order table"
                              >
                                <TableHead>
                                  <TableRow>
                                    {[
                                      "ITEM",
                                      "QTY",
                                      "RATE",
                                      "SUBTOTAL",
                                      "GST",
                                      "TOTAL",
                                    ].map((header) => (
                                      <TableCell
                                        key={header}
                                        sx={{
                                          color: "#0C1E5B",
                                          fontWeight: "bold",
                                          borderBottom: "2px solid black",
                                          ...(header === "QTY" && { pl: 25 }),
                                        }}
                                      >
                                        {header}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(modaldata?.purchaseItems || []).map(
                                    (row, index) => {
                                      const gst =
                                        (row?.cgstAmount || 0) +
                                        (row?.sgstAmount || 0) +
                                        (row?.igstAmount || 0);

                                      return (
                                        <TableRow
                                          key={index}
                                          sx={{
                                            color: "#0C1E5B",
                                            borderBottom: "2px solid black",
                                          }}
                                        >
                                          <TableCell>
                                            {row.itemDescription}
                                          </TableCell>
                                          <TableCell sx={{ pl: 25 }}>
                                            {row.quantity.toFixed(1)}
                                          </TableCell>

                                          <TableCell>
                                            {row.unitPrice.toFixed(1)}
                                          </TableCell>
                                          <TableCell>
                                            {row.subTotal.toFixed(1)}
                                          </TableCell>
                                          <TableCell>
                                            {gst.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {row.total.toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    },
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            {/* Total */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                mt: 4,
                                gap: 3,
                                mx: 2,
                              }}
                            >
                              <Typography
                                sx={{ fontWeight: "bold", color: "#0C1E5B" }}
                              >
                                TOTAL AMOUNT:
                              </Typography>
                              <Typography sx={{}}>
                                {" "}
                                Rs.{modaldata?.totalAmount.toFixed(2)}
                              </Typography>
                            </Box>

                            {/* T&C */}
                            <Box sx={{ mt: 4 }}>
                              <Typography
                                sx={{ fontWeight: "bold", color: "#0C1E5B" }}
                              >
                                TERMS AND CONDITIONS
                              </Typography>
                              <Typography>{termAndCondition}</Typography>
                            </Box>
                          </Box>
                        </Card>
                      );
                    })()}
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <AddPuchaseOrder
            getAllData={() => {
              if (userDetail?.profileId) {
                const val = userDetail.profileId.split("?")[1];
                const billerId = val?.split("=")[1]?.replace(/\D/g, "");
                getAllProdct({ billerId }, (res) => {
                  console.log("res getAll product ((((((((((", res?.data);
                  setCollection([...res?.data]);
                });
              }
            }}
            modaldata={modaldata}
            open={open}
            setOpen={setOpen}
            setModalData={setModalData}
          />
        </>
      )}

      {businessChooseTab?.value == "VenderRegistration" && (
        <VendorRegistration />
      )}
      {businessChooseTab?.value == "Quotation" && (
        // <Quatation />
        <QuetatioinPage />
      )}

      {businessChooseTab?.value == "TermsAndConditions" && (
        // <Quatation />
        <TermsAndConditions />
      )}
    </Box>
  );
};
